<template>
  <div class="pc-page">
    <div class="test_main test_main_4">
      <Nav></Nav>
      <div class="test_detail test_2">
        <div class="box">
          <em class="icon part_over"></em>
          <p class="tips">心理健康测评已完成！</p>
          <div class="btngroup">
            <a class="btn btn_goon" v-if="type!='test'" @click="jump()">点击继续</a>
           </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import Nav from '../../../../components/learningAbility/mentalHealth.vue';
  export default{
    data(){
      return {
        quitType: '',
        testType360: ''
      }
    },
    mounted(){
      $('.test_menu .item').addClass('item_4');
    },
    updated(){

    },
    methods: {
        jump() {
            this.$router.push('/cepingwancheng')
        }
    },
    components: {Nav},
  }
</script>
<style>
  .evalu-nav {
    background: #333;
    opacity: 1;
  }
</style>
